import { getOrgInfo } from 'api/get/people'
import React from 'react'
import { useQuery } from 'react-query'
import { Navigate, useLocation } from 'react-router-dom'
import Cookies from 'universal-cookie'

export const MyNetworkManager = ({
	children
}: {
	children: JSX.Element
}): JSX.Element => {
	const location = useLocation()
	const cookies = new Cookies()
	const roles = cookies.get('roles')
	const isSuperAdmin = cookies.get('isSuperAdmin')
	const organizationId = cookies.get('organization_id') as number

	const { data: orgInfo, isLoading } = useQuery(
		['orgInfo', organizationId],
		() => getOrgInfo(organizationId),
		{ enabled: !!organizationId && !isSuperAdmin }
	)

	if (!roles.find((item: number) => item === 4 || item === 5 || isSuperAdmin)) {
		return <Navigate to="/" state={{ from: location }} />
	}

	if (!isSuperAdmin && !isLoading && orgInfo?.active_my_network === false) {
		return <Navigate to="/" state={{ from: location }} />
	}

	return children
}
